import { AuthSsoMerchant } from "@CommonApi/auth/sso/merchants";
import { useAtom } from "jotai";
import { omniAtom } from "src/utils/atoms";

export const merchantsAtom = omniAtom({
  key: "merchants",
  value: [] as AuthSsoMerchant[], // Authorized pages all have user available.
});

export const useMerchants = () => {
  const [merchants, setMerchants] = useAtom(merchantsAtom);
  return { merchants, setMerchants, merchantsAtom };
};
